import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Services from '../components/Services'
import { API_URL } from '../config/api'
import FeedbackCarousel from "../components/FeedbackCarousel"
import './Home.css'

function Home() {
  const [aboutVideoUrl, setAboutVideoUrl] = useState(null)

  useEffect(() => {
    // Optimized Strapi query: Fetch only the required video URL field
    fetch(`${API_URL}/api/about-setting?populate[video][fields][0]=url`)
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        const video = data?.data?.attributes?.video?.data
        if (video?.attributes?.url) {
          setAboutVideoUrl(`${API_URL}${video.attributes.url}`)
        }
      })
      .catch(() => {})
  }, [])

  return (
    <div className="home">
      <section className="hero">
        <div className='heroImg'>
          <div className="hero-content">
            <h1>Professionele Carwraps</h1>
            <p>Transform uw voertuig met aangepaste carwraps en professioneel ontwerp</p>
            <div className="hero-buttons">
              <Link to="/projects" className="btn btn-primary">Bekijk Projecten</Link>
              <Link to="/contact" className="btn btn-secondary">Neem Contact Op</Link>
            </div>
          </div>
        </div>
      </section>

      <Services />

      <section className="about-us">
        {aboutVideoUrl && (
          <>
            <video
              className="about-video-bg"
              src={aboutVideoUrl}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
            />
            <div className="about-video-overlay" />
          </>
        )}
        <div className="about-us-inner">
          <h2>Over Ons</h2>
          <div className="about-content">
            <p>
              Alles begon in 2014 toen ik mijn passie voor auto's nog meer wou uitbreiden, van een uit de hand gelopen hobby gesproken!
            </p>
            <p>
              Ik ben zo gefascineerd hoe een wrap zo een auto kan veranderen en wil die ook meegeven met de mensen.
            </p>
            <p>
              Natuurlijk staat bij ons de kwaliteit en de klantopvolging op de eerste plaats en willen we niets anders dan de fijnste afwerking met de beste service!
            </p>
          </div>
        </div>
      </section>

      <section>
        <FeedbackCarousel />
      </section>
    </div>
  )
}

export default Home